import React, { useState } from "react";
import BillUploadButton from "./BillUploadButton";
import { ESTIMATE_APPROVAL_ARRAY } from "../utils";
import { userRoles, userStatus } from "../../../../../constants/user";
import { useAppSelector } from "../../../../../redux/store";
import { shallowEqual } from "react-redux";

type Props = {
  patient: any;
  selectedStatus: string;
  enhanceApprovalDocs: [
    { label: string; path: string }[],
    React.Dispatch<React.SetStateAction<{ label: string; path: string }[]>>
  ];
};

const EnhanceApproval = (props: Props) => {
  const { patient, selectedStatus } = props;

  const [enhanceApprovalDocs, setEnhanceApprovalDocs] =
    props.enhanceApprovalDocs;

  const { role } = useAppSelector((state) => {
    return state.auth.profileData.user;
  }, shallowEqual);

  
  const handleUpload = (data: string[]) => {
    const files = data.map((file, index) => ({
      label: `Enhance Approval Doc ${index + 1}`,
      path: file,
    }));

    setEnhanceApprovalDocs((prev: any) => [...files]);
  };


  return (
    <>
      {selectedStatus.split('_(')[0] === userStatus.ENHANCE_APPROVAL_REQUEST &&
        [userRoles.STAFF, userRoles.SUPER_ADMIN].includes(role) && (
          <div className="mg-y-16">
            <label className="form-label">Enhance Approval*</label>
            <BillUploadButton
              name="enhanceDocuments"
              callBack={handleUpload}
              documentTitle="Documents"
            />
          </div>
        )}
    </>
  );
};

export default EnhanceApproval;
